"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accidentals_to_props = exports.accidentals_to_metadata = exports.accidentals_pretty = exports.accidentals_code = exports.accidentals = void 0;
exports.addDurationSuffix = addDurationSuffix;
exports.annotation_position_to_character = void 0;
exports.describeAltoPitchPos = describeAltoPitchPos;
exports.describeBassPitchPos = describeBassPitchPos;
exports.describeNotation = describeNotation;
exports.describeNoteDuration = describeNoteDuration;
exports.describePitch = describePitch;
exports.describeTreblePitchPos = describeTreblePitchPos;
exports.durations = void 0;
exports.get_abs_pitch = get_abs_pitch;
exports.get_abs_pitch_number = get_abs_pitch_number;
exports.get_alto_pitch = get_alto_pitch;
exports.get_alto_pitch_number = get_alto_pitch_number;
exports.get_bass_pitch = get_bass_pitch;
exports.get_bass_pitch_number = get_bass_pitch_number;
exports.get_treble_pitch = get_treble_pitch;
exports.get_treble_pitch_number = get_treble_pitch_number;
exports.letterToBasePitch = exports.key_signature_alt_text = exports.icons = void 0;
exports.letter_to_pitch = letter_to_pitch;
exports.verticalPos_to_lineSpace = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _abcjs = _interopRequireDefault(require("@bittnerdevelopmentgroup/abcjs"));
var _fractional = require("fractional");
var _dblflat = _interopRequireDefault(require("../assets/MusicEditor/dblflat.png"));
var _dblflat_disabled = _interopRequireDefault(require("../assets/MusicEditor/dblflat_disabled.png"));
var _dblsharp = _interopRequireDefault(require("../assets/MusicEditor/dblsharp.png"));
var _dblsharp_disabled = _interopRequireDefault(require("../assets/MusicEditor/dblsharp_disabled.png"));
var _flat = _interopRequireDefault(require("../assets/MusicEditor/flat.png"));
var _flat_disabled = _interopRequireDefault(require("../assets/MusicEditor/flat_disabled.png"));
var _natural = _interopRequireDefault(require("../assets/MusicEditor/natural.png"));
var _natural_disabled = _interopRequireDefault(require("../assets/MusicEditor/natural_disabled.png"));
var _pause = _interopRequireDefault(require("../assets/MusicEditor/pause.png"));
var _play = _interopRequireDefault(require("../assets/MusicEditor/play.png"));
var _play_disabled = _interopRequireDefault(require("../assets/MusicEditor/play_disabled.png"));
var _sharp = _interopRequireDefault(require("../assets/MusicEditor/sharp.png"));
var _sharp_disabled = _interopRequireDefault(require("../assets/MusicEditor/sharp_disabled.png"));
var _whole = _interopRequireDefault(require("../assets/MusicEditor/whole.png"));
var _S = _interopRequireDefault(require("../assets/MusicEditor/S.png"));
var _A = _interopRequireDefault(require("../assets/MusicEditor/A.png"));
var _T = _interopRequireDefault(require("../assets/MusicEditor/T.png"));
var _B = _interopRequireDefault(require("../assets/MusicEditor/B.png"));
var _key_signature_alt_te, _durations;
var DEBUG = false;
var icons = exports.icons = {
  dblflat: _dblflat.default,
  dblflat_disabled: _dblflat_disabled.default,
  dblsharp: _dblsharp.default,
  dblsharp_disabled: _dblsharp_disabled.default,
  flat: _flat.default,
  flat_disabled: _flat_disabled.default,
  natural: _natural.default,
  natural_disabled: _natural_disabled.default,
  pause: _pause.default,
  play: _play.default,
  play_disabled: _play_disabled.default,
  sharp: _sharp.default,
  sharp_disabled: _sharp_disabled.default,
  whole: _whole.default,
  S: _S.default,
  A: _A.default,
  T: _T.default,
  B: _B.default
};
var letterToBasePitch = exports.letterToBasePitch = {
  "C": 0,
  "D": 1,
  "E": 2,
  "F": 3,
  "G": 4,
  "A": 5,
  "B": 6
};
function get_abs_pitch(i) {
  var pitch = {};
  if (i.pitch) {
    pitch = i;
    i = i.pitch;
  }
  var letters = ["C", "D", "E", "F", "G", "A", "B"];
  var suffix = "";
  while (i < 0) {
    suffix += ",";
    i += letters.length;
  }
  while (i >= letters.length) {
    suffix += "'";
    i -= letters.length;
  }
  if (pitch.accidental) {
    return accidentals[pitch.accidental] + letters[i] + suffix;
  }
  return letters[i] + suffix;
}
var key_signature_alt_text = exports.key_signature_alt_text = (_key_signature_alt_te = {
  C: "No key signature.",
  Amin: "No key signature.",
  G: "Key signature has one sharp: F.",
  Emin: "Key signature has one sharp: F.",
  D: "Key signature has two sharps: F, C.",
  Bmin: "Key signature has two sharps: F, C.",
  A: "Key signature has three sharps: F, C, G.",
  "F#min": "Key signature has three sharps: F, C, G.",
  E: "Key signature has four sharps: F, C, G, D.",
  "C#min": "Key signature has four sharps: F, C, G, D.",
  B: "Key signature has five sharps: F, C, G, D, A.",
  "G#min": "Key signature has five sharps: F, C, G, D, A.",
  "F#": "Key signature has six sharps: F, C, G, D, A, E.",
  "D#min": "Key signature has six sharps: F, C, G, D, A, E.",
  "C#": "Key signature has seven sharps: F, C, G, D, A, E, B.",
  Bbmin: "Key signature has seven sharps: F, C, G, D, A, E, B.",
  F: "Key signature has one flat: B.",
  Dmin: "Key signature has one flat: B.",
  Bb: "Key signature has two flats: B, E.",
  Gmin: "Key signature has two flats: B, E.",
  Eb: "Key signature has three flats: B, E, A.",
  Cmin: "Key signature has three flats: B, E, A.",
  Ab: "Key signature has four flats: B, E, A, D.",
  Fmin: "Key signature has four flats: B, E, A, D.",
  Db: "Key signature has four flats: B, E, A, D."
}, (0, _defineProperty2.default)(_key_signature_alt_te, "Bbmin", "Key signature has five flats: B, E, A, D, G."), (0, _defineProperty2.default)(_key_signature_alt_te, "Gb", "Key signature has six flats: B, E, A, D, G, C."), (0, _defineProperty2.default)(_key_signature_alt_te, "Ebmin", "Key signature has six flats: B, E, A, D, G, C."), (0, _defineProperty2.default)(_key_signature_alt_te, "Cb", "Key signature has seven flats: B, E, A, D, G, C, F."), (0, _defineProperty2.default)(_key_signature_alt_te, "Abmin", "Key signature has seven flats: B, E, A, D, G, C, F."), _key_signature_alt_te);
var verticalPos_to_lineSpace = exports.verticalPos_to_lineSpace = {
  "19": "fifth space above staff",
  "18": "fourth ledger line above staff",
  "17": "fourth space above staff",
  "16": "third ledger line above staff",
  "15": "third space above staff",
  "14": "second ledger line above staff",
  "13": "second space above staff",
  "12": "first ledger line above staff",
  "11": "first space above staff",
  "10": "fifth line",
  "9": "fourth space",
  "8": "fourth line",
  "7": "third space",
  "6": "third line",
  "5": "second space",
  "4": "second line",
  "3": "first space",
  "2": "first line",
  "1": "first space below staff",
  "0": "first ledger line below staff",
  "-1": "second space below staff",
  "-2": "second ledger line below staff",
  "-3": "third space below staff",
  "-4": "third ledger line below staff",
  "-5": "fourth space below staff",
  "-6": "fourth ledger line below staff",
  "-7": "fifth space below staff"
};
function get_treble_pitch(i, humanReadable) {
  return get_abs_pitch(i, humanReadable);
}
function get_bass_pitch(i, humanReadable) {
  return get_abs_pitch(i - 12, humanReadable);
}
function get_alto_pitch(i, humanReadable) {
  return get_abs_pitch(i - 6, humanReadable);
}
function get_abs_pitch_number(pitch) {
  var letters = ["C", "D", "E", "F", "G", "A", "B"];
  var num = letters.indexOf(pitch[0]);
  if (num === -1) {
    throw new Error("Invalid note name");
  }
  for (var i = 1; i < pitch.length; ++i) {
    if (pitch[i] === "'") {
      num += 12;
    } else if (pitch[i] === ",") {
      num -= 12;
    } else {
      throw new Error("Invalid note pitch");
    }
  }
  return num;
}
function get_treble_pitch_number(pitch) {
  return get_abs_pitch_number(pitch);
}
function get_bass_pitch_number(pitch) {
  return get_abs_pitch_number(pitch) + 12;
}
function get_alto_pitch_number(pitch) {
  return get_abs_pitch_number(pitch) + 6;
}
function letter_to_pitch(letter, clef) {
  var pitch = {};
  var letterCopy = letter;
  Object.values(accidentals).map(function (accidental) {
    var accidentalIndex = letter.indexOf(accidental);
    if (accidentalIndex !== -1) {
      pitch.accidental = accidentals_code[accidental];
      letterCopy = letter.substring(accidentalIndex + accidental.length, letter.length);
    }
  });
  var i = letterToBasePitch[letterCopy[0]];
  var noteCount = Object.keys(letterToBasePitch).length;
  while (letterCopy[1] === "'") {
    i += noteCount;
    letterCopy = letterCopy.slice(0, 1) + letterCopy.slice(2);
  }
  while (letterCopy[1] === ",") {
    i -= noteCount;
    letterCopy = letterCopy.slice(0, 1) + letterCopy.slice(2);
  }
  pitch.pitch = i;
  if (clef === "treble") {
    pitch.verticalPos = i;
  } else if (clef === "alto") {
    pitch.verticalPos = i + 6;
  } else {
    pitch.verticalPos = i + 12;
  }
  return pitch;
}
function addDurationSuffix(i) {
  if (i === 1) {
    return "whole";
  } else if (i === 2) {
    return "half";
  } else if (i === 4) {
    return "quarter";
  } else if (i >= 10 && i <= 20) {
    return i + "th";
  }
  var ones = i % 10;
  if (ones === 1) {
    return i + "st";
  } else if (ones === 2) {
    return i + "nd";
  } else if (ones === 3) {
    return i + "rd";
  }
  return i + "th";
}
function ordinal(i) {
  if (i >= 11 && i <= 13) {
    return i + "th";
  }
  var ones = i % 10;
  return i + ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][ones];
}
function describeNotation(notation, readAnnotations, parse) {
  if (parse === undefined) {
    parse = _abcjs.default.parseOnly(notation);
  }
  var ret = "";
  var _iterator = (0, _createForOfIteratorHelper2.default)(parse[0].lines),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var line = _step.value;
      var voicenum = 0;
      var _iterator2 = (0, _createForOfIteratorHelper2.default)(line.staff),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var staff = _step2.value;
          var clef = staff.clef.type;
          var key = "no accidentals";
          if (staff.key.accidentals.length > 0) {
            key = "".concat(staff.key.accidentals.length, " accidental").concat(staff.key.accidentals.length === 1 ? '' : 's');
          }
          ret += " ".concat(clef, " clef with ").concat(key).concat(staff.voices.length > 1 ? ',' : ':');
          var _iterator3 = (0, _createForOfIteratorHelper2.default)(staff.voices),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var voice = _step3.value;
              ++voicenum;
              if (staff.voices.length > 1) {
                ret += " ".concat(ordinal(voicenum), " voice: ");
              }
              var _iterator4 = (0, _createForOfIteratorHelper2.default)(voice),
                _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var note = _step4.value;
                  if (note.el_type === "note") {
                    var duration = describeNoteDuration(note.duration);
                    if (note.rest) {
                      ret += " ".concat(duration, " rest");
                    } else {
                      var pitches = [];
                      var _iterator5 = (0, _createForOfIteratorHelper2.default)(note.pitches),
                        _step5;
                      try {
                        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                          var pitch = _step5.value;
                          pitches.push(describePitch(pitch));
                        }
                      } catch (err) {
                        _iterator5.e(err);
                      } finally {
                        _iterator5.f();
                      }
                      if (note.pitches.length === 1) {
                        ret += " ".concat(pitches.join(' '), " ").concat(duration, " note");
                      } else {
                        ret += " [".concat(pitches.join(' '), "] ").concat(duration, " chord");
                      }
                    }
                  } else if (note.el_type === "bar") {
                    if (note.type === "bar_thin") {
                      ret += ",";
                    } else if (note.type === "bar_thin_thin") {
                      ret += ".";
                    } else if (note.type === "bar_left_repeat") {
                      ret += ". start repeat:";
                    } else if (note.type === "bar_right_repeat") {
                      ret += ". end repeat.";
                    } else {
                      DEBUG && console.log("describeNotation bar unknown", note.type);
                    }
                  } else {
                    DEBUG && console.log("describeNotation type unknown", note.el_type, note);
                  }
                  if (note.chord && readAnnotations) {
                    var _iterator6 = (0, _createForOfIteratorHelper2.default)(note.chord),
                      _step6;
                    try {
                      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                        var chord = _step6.value;
                        ret += " annotated \"".concat(chord.name, "\"");
                      }
                    } catch (err) {
                      _iterator6.e(err);
                    } finally {
                      _iterator6.f();
                    }
                  }
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return ret;
}
function describeTreblePitchPos(i) {
  return describePitch({
    pitch: i
  });
}
function describeBassPitchPos(i) {
  return describeTreblePitchPos(i - 12);
}
function describeAltoPitchPos(i) {
  return describeTreblePitchPos(i - 6);
}
function describePitch(pitch) {
  var i = pitch.pitch;
  var letters = ["C", "D", "E", "F", "G", "A", "B"];
  var octave = 4;
  while (i < 0) {
    octave--;
    i += letters.length;
  }
  while (i >= letters.length) {
    octave++;
    i -= letters.length;
  }
  if (pitch.accidental) {
    return "".concat(letters[i], " ").concat(pitch.accidental, " ").concat(octave);
  }
  return letters[i] + octave;
}
function describeNoteDuration(duration) {
  var frac = new _fractional.Fraction(duration);
  if (frac.numerator === 1) {
    return addDurationSuffix(frac.denominator);
  } else if (frac.denominator == 1) {
    return ["", "whole", "double whole", "triple whole", "quadruple whole"][frac.numerator];
  } else if (frac.numerator === 3) {
    return "dotted " + addDurationSuffix(frac.denominator / 2);
  } else if (frac.numerator === 7) {
    return "double dotted" + addDurationSuffix(frac.denominator / 4);
  }
  return frac.numerator + "/" + addDurationSuffix(frac.denominator);
}
var durations = exports.durations = (_durations = {
  1: "𝅝"
}, (0, _defineProperty2.default)(_durations, 1 / 2, "𝅗𝅥"), (0, _defineProperty2.default)(_durations, 1 / 4, "𝅘𝅥"), (0, _defineProperty2.default)(_durations, 1 / 8, "𝅘𝅥𝅮"), (0, _defineProperty2.default)(_durations, 1 / 16, "𝅘𝅥𝅯"), _durations);

// const dot = "𝅭"

var accidentals = exports.accidentals = {
  sharp: "^",
  flat: "_",
  natural: "=",
  dblsharp: "^^",
  dblflat: "__"
};
var accidentals_code = exports.accidentals_code = {
  "^": "sharp",
  "_": "flat",
  "=": "natural",
  "^^": "dblsharp",
  "__": "dblflat"
};
var accidentals_pretty = exports.accidentals_pretty = {
  sharp: "♯",
  flat: "♭",
  natural: "♮",
  dblsharp: "𝄪",
  dblflat: "𝄫"
};
var accidentals_to_metadata = exports.accidentals_to_metadata = {
  sharp: "music_button_sharp",
  flat: "music_button_flat",
  natural: "music_button_natural",
  dblsharp: "music_button_double_sharp",
  dblflat: "music_button_double_flat"
};
var accidentals_to_props = exports.accidentals_to_props = {
  sharp: "musicButtonSharp",
  flat: "musicButtonFlat",
  natural: "musicButtonNatural",
  dblsharp: "musicButtonDoubleSharp",
  dblflat: "musicButtonDoubleFlat"
};
var annotation_position_to_character = exports.annotation_position_to_character = {
  below: "_",
  above: "^",
  left: "<",
  right: ">",
  default: ""
};